import { render, staticRenderFns } from "./Reglements.vue?vue&type=template&id=69936147&scoped=true&"
import script from "./Reglements.vue?vue&type=script&lang=js&"
export * from "./Reglements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69936147",
  null
  
)

export default component.exports